<template>
  <div :class="{'hidden':hidden}" class="pagination-container pagination">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '../../util/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100, 200]
      }
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    scrollNum: {
      type: Number,
      default: 200
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      if (this.currentPage * val > this.total) {
        this.currentPage = 1
      }
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(this.scrollNum, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(this.scrollNum, 800)
      }
    }
  }
}
</script>

<style lang="css">
.pagination {
  display: flex;
  justify-content: center;
  margin: 2rem 0 2rem;
}

.pagination .el-pagination__sizes .el-input__inner{
  height: 50px;
  color: #999;
  font-family: 'HarmonyOS_Sans_Medium' !important;
  font-size: 0.75rem;
}

.el-pagination .el-pagination__total{
  height: 50px !important;
  color: #999 !important;
  line-height: 50px !important;
  font-family: 'HarmonyOS_Sans_Medium' !important;
  font-size: 0.8rem !important;
  display: inline-flex;
  align-items: center !important;
  justify-content: center !important;
}

.el-scrollbar__view .el-select-dropdown__item span{
  color: #999;
  font-family: 'HarmonyOS_Sans_Medium' !important;
  font-size: 0.75rem;
}

.el-scrollbar__view .el-select-dropdown__item.selected span{
  color: #00db6d;
  font-family: 'HarmonyOS_Sans_Medium' !important;
  font-size: 0.75rem;
}

.pagination li, .pagination .btn-prev, .pagination .btn-next {
  width: 50px;
  height: 50px;
  border: 1px solid #ebebeb !important;
  display: inline-flex;
  align-items: center !important;
  justify-content: center !important;
  font-size: 0.75rem !important;
  color: #999 !important;
  font-weight: normal;
  background-color: #FFFFFF !important;
  margin: 0 0 0 0 !important;
}
.pagination li.number {
  font-family: "HarmonyOS_Sans_Medium" !important;
}
.pagination li.active {
  background-color: #00db6d !important;
  border: 1px solid #00db6d !important;
  transition: all .6s !important;
  color: #FFFFFF !important;
}
.pagination li:hover, .pagination .btn-prev:hover, .pagination .btn-next:hover{
  background-color: #2fe78b !important;
  border: 1px solid #2fe78b !important;
  color: #FFFFFF !important;
}
.pagination li:hover a{
  color: #fff !important;
}

.pagination li.active a,
.pagination li.active span {
  color: #fff !important;
}
@media screen and (max-width:900px) {
  .pagination li, .pagination .btn-prev, .pagination .btn-next {
    width: 25px !important;
    height: 25px !important;
  }
  .el-pagination .el-pagination__total {
    height: 25px !important;
    line-height: 25px !important;
    display: none !important;
  }
  .pagination .el-pagination__sizes .el-input__inner {
    height: 25px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue